module.exports = __webpack_public_path__ + "img/dispose2.6af6aa1b.png";